import NotAllowed from "./NotAllowed";

/** Route-level 403 — same compact Access Denied UI as in-app permission blocks. */
const NotAuthorized = () => <NotAllowed />;

export default NotAuthorized;
